const baseUrl = '/api/exam-appeal/v1';

export default {
  baseUrl,
  getNotCorrectExamUrl: () => `${baseUrl}/denial`,
  getAppealSubmitUrl: () => `${baseUrl}/submit`,
  getAppealCancelUrl: () => `${baseUrl}/cancel`
};
